import React from "react";
import { useNavigate } from "react-router-dom";
import {
  LayoutMain,
  Background,
  MainCarousel,
  //TemplateOffer,
  NoOfferFound,
} from "../../components/common";
import { Row, Col } from "react-bootstrap";
import "./Home.css";
import { SimpleButton } from "../../components/styles";

import offersAvalanche from "../../data/offersAvalanches";
import offersMountainguide from "../../data/offersMountainguide";
import offersTravel from "../../data/offersTravel";

function Home() {
  const baseImagePath = process.env.REACT_APP_BASE_IMAGE_PATH;
  const navigate = useNavigate(); // Get the navigate function

  /*selection of offers for slider from all data offers available*/
  const selectedOffers = [
    offersAvalanche.find((offer) => offer.id === "a1"),
    offersTravel.find((offer) => offer.id === "t1"),
    offersTravel.find((offer) => offer.id === "t2"),
    offersMountainguide.find((offer) => offer.id === "m3"),
    offersMountainguide.find((offer) => offer.id === "m1"),
    offersMountainguide.find((offer) => offer.id === "m2"),
  ];

  const handleButtonClick = () => {
    navigate(`/booking/a2`); // Navigate to the booking page with the "a2" ID
  };

  return (
    <LayoutMain>
      <Background image={`${baseImagePath}home/background/welcome_image.jpg`}>
        <div className="headline-home">
          <h1>KaMikaze Travel</h1>
          <h4>Reisen um zu Erleben!</h4>
        </div>
      </Background>
      <div className="home-container">
        <Row>
          <Col>
            <section className="introduction-home">
              <h2>individuell - eindrucksvoll - alpin</h2>
              <p>
                Als kleines Individualreisebüro bieten wir passgenaue kleine und
                große, alpine als auch plaisir Touren und Reisen an. Besuche mit
                uns eindrucksvolle Landschaften in Österreich, Europa und der
                Welt.
              </p>
            </section>
          </Col>
        </Row>

        {/* ---- START SECTION TO ADD CURRENT FLYER IF ANY AVAILABLE -----  
        <div className="home-flyer">
          <img
            src={`${baseImagePath}flyer/SSC2024.png`}
            alt="Flyer"
            className="flyer-image"
          />

          <SimpleButton
            label="Hier Buchen"
            onClick={handleButtonClick}
            variant="primary"
          />
        </div>

        /* ---- END SECTION TO ADD CURRENT FLYER IF ANY AVAILABLE -----  */}

        <div className="home-carousel">
          <MainCarousel offers={selectedOffers} />
        </div>

        <NoOfferFound
          heading="Kein passendes Angebot gefunden?"
          description="Kein Problem! Wir planen gerne eine individuelle und einzigartige Reise oder Tour, die ganz auf deine Wünsche zugeschnitten ist. Lass uns deine Vorstellungen wissen, und wir erstellen das perfekte Reiseerlebnis für dich."
          buttonText="Schreib uns!"
          buttonLink="/contact"
        />

        {/* Two-column section with divider */}
        <div className="home-two-column-section">
          <div className="home-divider"></div>
          <Row>
            <Col md={6} className="column-left">
              <h3>Wir sind die Expert:innen für Alpine Reisen </h3>
              <p>
                Berge als Mittel um sich selbst wahrzunehmen, Grenzen kennen zu
                lernen, Schönheit in seiner Einfachheit zu erfahren – dafür sind
                wir die Expert:innen. Katharina bereiste allein als auch mit
                interessanten Menschen die Berge Mittel-, Süd -und Westeuropas
                sowie Südamerikas. Immer verbunden mit kulturellen,
                kulinarischen und menschlichen Highlights. Michael stand als
                Alpinist und Bergführer schon auf den interessantesten Graten,
                Gipfeln und Landschaften. Unser gemeinsames Wissen und unsere
                gemeinsame Begeisterung für die Natur, die uns umgibt, möchten
                wir mit Dir gemeinsam erleben.
              </p>
            </Col>
            <Col md={6} className="column-right">
              <h3>Große Abenteuer - wertschätzende Kleinigkeiten </h3>
              <p>
                Gemeinsam mit Menschen vor Ort suchen wir für Dich die
                Einzigartigkeit der Landschaften, Kulturen und Genüsse. Um mit
                offenen Sinnen unsere Umgebungen und Eindrücke wahrnehmen zu
                können, führen wir Dich sicher durch anstehende
                Herausforderungen und Erlebnisse.
              </p>
            </Col>
          </Row>
        </div>
      </div>
    </LayoutMain>
  );
}

export default Home;
